export enum SuggestionType {
    skill = 'skill',
    industry = 'industry',
    priority = 'priority',
}
